import React from "react";
import OwlCarousel from "react-owl-carousel3";
// import "owl.carousel/dist//owl.carousel.css";
// import "owl.carousel/dist//owl.theme.default.css";

const galleryImages = [

  { src: "/images/gallery/slid/5.jpg" },
  { src: "/images/gallery/slid/6.jpg" },
  { src: "/images/gallery/slid/8.jpg" },
 
  // { src: "/images/gallery/slid/10.jpg" },
  { src: "/images/gallery/slid/11.jpg" },
  { src: "/images/gallery/slid/12.jpg" },
  { src: "/images/gallery/slid/13.jpg" },
  { src: "/images/gallery/slid/14.jpg" },

  
];

const options = {
  loop: true,
  margin: 0,
  nav: false,
  dots: false,
  autoplay: true,
  autoplayTimeout: 7000,
  smartSpeed: 1800,
  responsive: {
    0: { items: 1 },
    768: { items: 3 },
    1000: { items: 5 },
  },
};

const GallerySection = () => {
  return (
    <section className="gallery-section">
      <div className="container-fluid">
        <OwlCarousel className="owl-theme" {...options}>
          {galleryImages.map((img, index) => (
            <div className="gallery-image-block" key={index}>
              <figure className="gallery-image Borderr p=2">
                <img src={img.src} alt={`Gallery ${index + 1}`} />
              </figure>
              <a
                href={img.src}
                className="lightbox-image Borderr"
                data-fancybox="gallery"
              >
                {/* <img
                  src="/images/icons/arrowsout.png"
                  alt="Open"
                  className="-icon Borderr"
                /> */}
              </a>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </section>
  );
};

export default GallerySection;
